const $body = $('body');
const $masthead = $('.masthead');

// menu-toggle
$('[data-toggle="menu"]').on('click', function (e) {
    e.preventDefault();

    if ($body.hasClass('show-menu')) {
        hideMenu();
    } else {
        showMenu();
    }
});

function showMenu() {
    $body.addClass('show-menu');

    if ($masthead.hasClass('masthead--inverted')) {
        $masthead.removeClass('masthead--inverted').addClass('masthead--reapply-inverted');
    }
}

function hideMenu() {
    $body.removeClass('show-menu');

    if ($masthead.hasClass('masthead--reapply-inverted')) {
        $masthead.addClass('masthead--inverted').removeClass('masthead--reapply-inverted');
    }
}

// actions on key press
$(document).keyup(function(e) {
    if (e.key === "Escape") {
        hideMenu();
    }
});
